<template>
  <div class="details_content_all">
    <div class="details_content_repeat">
      <QS-h4-title title="订单收款信息" />
      <div class="details_content_repeat_hundred">
        <div v-if="!tabType" class="details_content_repeat_btns">
          <el-button
            type="primary"
            :disabled="batchOfflineCollectAble"
            @click="batchOfflineCollect"
          >
            批量线下收款
          </el-button>
          <i class="cut-off"></i>
          <el-button
            @click="showOrderReceiptDialog = true"
            >订单收款记录</el-button
          >
        </div>
        <!-- 收款信息列表 -->
        <QS-common-table
          :header-cell-class-name="cellClass"
          v-loading="receiptLoading"
          :columns="m_receiptColumns"
          :pagination="receiptPagination"
          :data="receiptData"
          @change="receiptTableChange"
          @selection-change="
            (selectedItems) => {
              this.receiptSelectedItems = selectedItems
            }
          "
        ></QS-common-table>
      </div>
    </div>

    <div class="details_content_repeat MarTop">
      <QS-h4-title title="订单付款信息" />
      <div class="details_content_repeat_hundred">
        <QS-common-table
          v-loading="paymenteObj.loading"
          :columns="m_paymentColumns"
          :data="paymenteData"
          :pagination="paymenteObj"
          @change="paymentPageChange"
        ></QS-common-table>
      </div>
    </div>

    <!-- 订单收款记录弹窗 -->
    <dialogWrap
      v-model="showOrderReceiptDialog"
      :width="'824px'"
      title="订单收款记录"
    >
      <orderReceiptList @revokeSuccess="revokeSuccess" />
    </dialogWrap>

    <!-- 订单付款信息弹窗 -->
    <dialog-wrap-upgrade
      ref="offlinePaymentRef"
      :configOptions="offlinePaymentOption"
      v-loading="offlinePaymentLoading"
    >
      <!-- optionType 1收款单 2付款单 -->
      <!-- type 1新增  2编辑 -->
      <AddReceipt
        v-if="showPayBill"
        ref="addPayment"
        :data="detailSource"
        :optionType="2"
        :type="1"
      ></AddReceipt>
    </dialog-wrap-upgrade>
  </div>
</template>

<script>
import {
  addPaymentOrder,
  getPaymentDetails,
  getPaymentList,
  getReceivableList,
} from '@/api/domain/finance.js'
import * as globalApi from '@/api/global'
import selectOption from '@/store/dict/selectOptionDict'
import AddReceipt from '@/pages/finance/addReceipt'
import { mapState } from 'vuex'
import orderReceiptList from './components/orderReceiptList/index'
import mixins from './mixins/index'
import { batchOfflineCollectCheck } from '@/pages/utils/overdue'

export default {
  name: 'Receiptandpayment',
  mixins: [mixins],
  components: { orderReceiptList, AddReceipt },
  data() {
    return {
      // 展示收款单弹窗
      showPayBill: false,
      dingTalkShow: false,
      receiptLoading: false,
      // 是否展示收款记录弹窗
      showOrderReceiptDialog: false,
      // 收款数据
      receiptData: [],
      // 收款被选中项
      receiptSelectedItems: [],
      // 付款数据
      paymenteData: [],
      // 收款--分页
      receiptPagination: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      // 付款--分页
      paymenteObj: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        loading: false,
      },
      orderId: '', // 订单ID
      // 线下付款弹窗
      offlinePaymentLoading: false,
      detailSource: {},
      sourceOrderTypeDict: selectOption.sourceOrderTypeDict,
      // eslint-disable-next-line vue/no-unused-properties
      completionStatusDict: selectOption.completionStatusDict,
      paymentStatusDict: selectOption.paymentStatusDict,
    }
  },
  props: ['tabType'],
  inject: ['orderData'],
  watch: {
    orderData: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.orderId) {
          this.orderId = newVal.orderId
          this.getReceivableList() // 应收列表
          this.getPaymentList() // 应付列表
        }
      },
    },
  },
  computed: {
    offlinePaymentOption() {
      return {
        attrs: {
          title: '新增付款单',
          width: '900px',
        },
        footerList: [
          {
            text: '取消',
            options: {
              type: 'default',
            },
            isShowBtn: true,
            click: () => this.closePayBill(),
          },
          {
            text: this.dingTalkShow ? '提交审批' : '确认新增',
            options: {
              type: 'primary',
            },
            isShowBtn: true,
            click: () => this.addPayment(),
          },
        ],
        // isShowClose: true,
        isDefaultMode: true,
        // closeText: '取消'
      }
    },
    batchOfflineCollectAble() {
      return !this.receiptSelectedItems.length
    },
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
  },
  created() {
    this.getDingTalkBtnShow()
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
  },
  methods: {
    // 获取钉钉审批按钮开启
    getDingTalkBtnShow() {
      globalApi
        .getSubmitDingTalkShow({
          bizType: 22,
        })
        .then((res) => {
          const { code, data } = res
          if (code !== 1) return
          this.dingTalkShow = data
        })
    },
    // 根据订单类型和线下收款类型（payType:{batch:批量，single:单条}）获取审批来源 (approvalOrigin)
    // 1: '应收列表线下收款',2: '应收列表批量线下收款',3: '个人订单详情线下收款',4: '个人订单详情批量线下收款',
    // 5: '企业租赁订单详情线下收款',6: '企业租赁订单详情批量线下收款',7: '催收预提醒线下收款',8: '催收逾期线下收款',
    // 9: '采购订单详情线下收款',10: '采购订单详情批量线下收款'
    getApprovalOrigin(payType) {
      const { orderType = '' } = this.$route.query
      if (!(orderType && payType)) return ''
      // 个人租赁订单-线下收款
      if (orderType === 'personal' && payType === 'single') return 3
      // 个人租赁订单-线下批量收款
      if (orderType === 'personal' && payType === 'batch') return 4
      // 企业租赁订单-线下收款
      if (orderType === 'enterChild' && payType === 'single') return 5
      // 企业租赁订单-线下批量收款
      if (orderType === 'enterChild' && payType === 'batch') return 6
      // 采购订单-线下收款
      if (orderType === 'purchaseSonOrder' && payType === 'single') return 9
      // 采购订单-线下批量收款
      if (orderType === 'purchaseSonOrder' && payType === 'batch') return 10
    },
    cellClass(row) {
      // this.receiptData = []
      // 获取可选数据的条数的长度（剩余应收金额为0，item.remainAmount === 0 ）
      const len = this.receiptData.filter(
        (item) =>
          !(
            Number(item.remainAmount) === 0 ||
            item.receivableState === '已完成' ||
            item.receivableState === '已关闭'
          ),
      ).length
      if (row.columnIndex === 0 && !len) {
        return 'disableSelection'
      }
    },
    revokeSuccess() {
      this.getReceivableList()
    },
    // 批量线下收款能力
    batchOfflineCollect() {
      // 筛选出所有订单ID
      const idList = this.receiptSelectedItems.map((obj) => obj.id).join(',')
      batchOfflineCollectCheck(idList).then((res) => {
        if (res?.code === 1) {
          this.$EventBus.$on('batchOfflineCollectSuccess', this.revokeSuccess)
          // 进行页面跳转
          this.$router.push({
            path: '/workbench/batchCollectionRecordAdd',
            query: {
              paymentIds: idList,
              type: 'order',
              approvalOrigin: this.getApprovalOrigin('batch'),
            },
          })
        }
      })
    },
    // 应收列表
    async getReceivableList() {
      const { code, data } = await getReceivableList({
        sourceOrderId: this.orderId,
        pageNum: this.receiptPagination.pageNum,
        pageSize: this.receiptPagination.pageSize,
        sourceOrderType: 5, // 5-采购订单
      })
      this.receiptLoading = false
      if (code === 1) {
        this.receiptData = data.items
          ? data.items.map((item) => {
            return {
              ...item,
              changeState: selectOption.payeechange[item.changeState],
              receivableState:
                  selectOption.completionStatusDict[item.receivableState],
              content: this.formatEnumeration(this.freeTypeList)[
                item.content
              ],
            }
          })
          : []
        this.receiptPagination.total = data.totalNum
      }
    },
    // 应收分页事件
    receiptTableChange(payload) {
      this.receiptLoading = true
      this.receiptPagination.pageNum = payload.pagination.pageNum
      this.receiptPagination.pageSize = payload.pagination.pageSize
      this.getReceivableList()
    },
    // 执行线下收款
    // eslint-disable-next-line vue/no-unused-properties
    offlineReceipt({ id }) {
      const query = {
        type: 'order',
        paymentIds: id,
        approvalOrigin: this.getApprovalOrigin('single'),
      }
      // 进行页面跳转
      this.$router.push({
        // path: '/purchase/batchCollectionRecordAdd',
        path: '/workbench/batchCollectionRecordAdd',
        query,
      })
    },
    // 应付列表
    async getPaymentList() {
      this.paymenteObj.loading = true
      try {
        const { code, data } = await getPaymentList({
          sourceOrderId: this.orderId,
          pageNum: this.paymenteObj.pageNum,
          pageSize: this.paymenteObj.pageSize,
          sourceOrderType: 5, // 5-采购子订单
        })
        if (code === 1) {
          this.paymenteData = data.items.map((item) => {
            return {
              ...item,
              changeState: selectOption.payeechange[item.changeState],
              payState: selectOption.paymentStatusDict[item.payState],
              // payType: selectOption.collectionContentDict[item.payType],
              payType: this.formatEnumeration(this.freeTypeList)[item.payType],
            }
          })
          this.paymenteObj.total = data.totalNum
        }
        this.paymenteObj.loading = false
      } catch (_) {
        this.paymenteObj.loading = false
      }
    },

    // 订单付款信息表格分页
    paymentPageChange(payload) {
      const { pagination } = payload
      // 更新页码信息
      this.paymenteObj.pageNum = pagination.pageNum
      this.paymenteObj.pageSize = pagination.pageSize
      this.getPaymentList()
    },
    // 线下付款
    // eslint-disable-next-line vue/no-unused-properties
    async offlinePayment(row) {
      await this.getPaymentDetails(row.id)
      this.openPayBill()
    },
    // 获取应付详情
    async getPaymentDetails(id) {
      const { data } = await getPaymentDetails({ id })
      this.detailSource = {
        ...data,
        payAmount: `${this.numberWithCommas(data.payAmount)}元`,
        paidAmount: `${this.numberWithCommas(data.paidAmount)}元`,
      }
      Object.keys(this.detailSource).forEach((item) => {
        switch (item) {
          case 'sourceOrderType':
            this.detailSource[item] =
              this.sourceOrderTypeDict[this.detailSource[item]]
            break
          case 'payState':
            this.detailSource[item] =
              this.paymentStatusDict[this.detailSource[item]]
            break
          case 'payType':
            this.detailSource[item] = this.formatEnumeration(this.freeTypeList)[
              this.detailSource[item]
            ]
            break
          default:
            break
        }
      })
    },
    // 确认新增付款
    async addPayment() {
      const data = await this.$refs.addPayment.formValidate()
      this.offlinePaymentLoading = true
      const { code } = data && (await addPaymentOrder(data))
      this.offlinePaymentLoading = false
      if (code !== 1) return
      const msg = this.dingTalkShow ? '提交审批成功' : '操作成功'
      data && this.$message.success(msg)
      data &&
        this.paymentPageChange({ pagination: { pageNum: 1, pageSize: 10 } })
      this.closePayBill()
      this.detailSource = {}
    },
    // 关闭付款弹窗
    closePayBill() {
      this.showPayBill = false
      this.$refs.offlinePaymentRef.close()
    },
    // 显示付款弹窗
    openPayBill() {
      this.showPayBill = true
      this.$refs.offlinePaymentRef.showDialog()
    },
  },
  beforeDestroy() {
    // 移除事件监听
    this.$EventBus.$off('batchOfflineCollectSuccess', this.revokeSuccess)
  },
}
</script>

<style lang="scss" scoped>
// .MarTop {
//   margin-top: 120px;
// }

// 按钮中间竖线样式
.details {
  &_content {
    &_repeat {
      &_btns {
        .cut-off {
          border-right: 1px solid #dcdee0;
          height: 24px;
          display: inline-block;
          vertical-align: middle;
          margin: 0px 5px;
        }

        margin-bottom: 16px;
      }
    }
  }
}
// 隐藏全选框
::v-deep .disableSelection .cell .el-checkbox__inner {
  display: inline-block;
  position: relative;
  border-radius: 2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  border-color: #dcdfe6;
  background-color: #f5f7fa;
  cursor: not-allowed;
  z-index: 1;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
}

::v-deep .self-dialog-new .el-dialog__footer .dialog-footer-new {
  justify-content: end;
}
</style>
